<absensi-tranfer-form>
    <div class="container">

        <template if={state.showToast}>
            <template if={state.success}>
                <div class="toast toast-success">
                    <button class="btn btn-clear float-right" onclick={closeToast}></button>
                    {state.toastMessage}
                </div>
            </template>

            <template if={!state.success}>
                <div class="toast toast-error">
                    <button class="btn btn-clear float-right" onclick={closeToast}></button>
                    {state.toastMessage}
                </div>
            </template>
        </template>
    </div>
    <div class="container">
        <div class="columns">
            <div class="column">
                <!-- column content -->
                <div class="panel">
                    <div class="panel-header">
                        <div class="panel-title">Source</div>
                    </div>
                    <div class="panel-nav">

                    </div>
                    <div class="panel-body">
                        <div class="form-group">
                            <select id="source-academic_year" class="form-select" onchange={onChangeAcademic}>
                                <option disabled selected>Tahun Akademik - Semester</option>
                                <option each={academicYear in state.academicYears} value={academicYear.ID}>{academicYear.label}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <select id="source-class_label" class="form-select" onchange={onChangeClass}>
                                <option disabled selected>Pilih Kelas</option>
                                <option each={classItem in state.classItems} value={classItem.label}>{classItem.label}</option>
                            </select>
                        </div>
                    </div>
                    <div class="panel-footer">
                        <!-- buttons or inputs -->
                    </div>
                </div>
            </div>
            <div class="divider-vert" data-content="To"></div>
            <div class="column">
                <!-- column content -->
                <div class="panel ">
                    <div class="panel-header">
                        <div class="panel-title">Destination</div>
                    </div>
                    <div class="panel-nav">

                    </div>
                    <div class="panel-body">
                        <div class="form-group">
                            <select id="dest-academic_year" class="form-select" onchange={onChangeAcademic}>
                                <option disabled selected>Tahun Akademik - Semester</option>
                                <option each={academicYear in state.academicYears} value={academicYear.ID}>{academicYear.label}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <select id="dest-class_label" class="form-select" onchange={onChangeClass}>
                                <option disabled selected>Pilih Kelas</option>
                                <option each={classItem in state.classItems} value={classItem.label}>{classItem.label}</option>
                            </select>
                        </div>
                    </div>
                    <div class="panel-footer">
                        <!-- buttons or inputs -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container" style="margin-top: 2%;">
        <div class="columns">
            <div class="column">
                <!-- column content -->
            </div>
            <div class="column">
                <!-- column content -->
            </div>
            <div class="column">
                <button class="btn btn-default btn-lg {state.loadingButton}" onclick={transfer}>Transfer</button>
            </div>
        </div>
    </div>
    <script>
        import Toast from '../../../toast/toast.riot';
        export default {
            components: {
                Toast,
            },
            state: {
                classItems: [],
                academicYears: [],
                toastMessage: '',
                success: undefined,
                loadingButton: '',
            },
            onMounted(props, state) {
                // right after the component is mounted on the page
                this.loadClasses();
                this.loadAcademicYears();
            },
            loadClasses() {
                axios.get(`/api/v1/classes`)
                    .then(res => {
                        this.update({
                            classItems: res.data.items,
                        })
                    })
            },
            loadAcademicYears() {
                axios.get(`/api/v1/academic-years`)
                    .then(res => {
                        this.update({
                            academicYears: res.data.items,
                        })
                    })
            },
            transfer(e) {
                e.preventDefault();
                let sourceAcademic = document.getElementById('source-academic_year').value;
                let sourceClass = document.getElementById('source-class_label').value;
                let destAcademic = document.getElementById('dest-academic_year').value;
                let destClass = document.getElementById('dest-class_label').value;
                let payload = {
                    "sourceAcademicYearId": sourceAcademic,
                    "sourceClassLabel": sourceClass,
                    "destinationAcademicYearId": destAcademic,
                    "destinationClassLabel":destClass,
                }
                this.update({
                    loadingButton: 'loading',
                })
                axios({
                    method: 'POST',
                    url: '/api/v1/student/class/transfer',
                    data: payload,
                }).then((resp) => {
                    console.log(resp)
                    this.update({
                        toastMessage: 'Data berhasil di-import',
                        success: true,
                        showToast: true,
                    })
                }).catch(e => {
                    this.update({
                        toastMessage: 'Data tidak berhasil di-import',
                        success: false,
                        showToast: true,
                    })
                    console.log(e)
                }).finally(() => {
                    this.update({
                        loadingButton: '',
                    })
                });
            }
        }
    </script>
</absensi-tranfer-form>
